import { get } from 'lodash';
import { connect } from 'react-redux';

import CartItem from 'components/CartItem';
import CartSelector from 'state/selectors/cart';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const lineItems = CartSelector.getCartItemsData(state);
  const itemData = get(lineItems, id);

  if (!itemData) {
    return {
      isLoading: true,
      item: null,
    };
  }

  return {
    isLoading: false,
    item: {
      id,
      type: itemData.lineItemType,
    },
  };
};

export default connect(mapStateToProps)(CartItem);
